import { IDose } from 'daily-dose-common'
import { v4 as uuidv4 } from 'uuid'

export const collectIdAndDocs = (doc) => {
  return {
    id: doc.id,
    ...doc.data(),
  }
}

export const orderBy = (
  array: IDose[],
  value: keyof IDose,
  mode: 'asc' | 'desc'
) => {
  if (mode === 'desc') {
    return array.sort((a, b) => b[value] - b[value])
  } else {
    return array.sort((a, b) => a[value] - b[value])
  }
}

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0
}

/**
 * Check if an email is valid based on Regex
 * @param value string to evaluate
 * @return boolean
 */
export const isValidEmail = (value: string) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (re.test(String(value).toLowerCase())) {
    return true
  }
  return false
}

/**
 * Create a random a random id
 * @return {object} with 200 uniqueIds
 */
export const createRandomSorted = () => {
  const objects = {}

  for (let x = 0; x < 15; x++) {
    objects[x] = uuidv4()
  }

  return objects
}

/**
 * Get keys of suggested doses
 * @returns {string[]} array of keys of suggested doses
 */
export const KEYS_SUGGESTED_DOSES = [
  'description',
  'name',
  'randomId',
  'randomA',
  'randomB',
  'randomC',
  'randomD',
  'randomE',
  'randomF',
  'randomG',
  'randomH',
  'randomI',
  'randomJ',
  'randomK',
  'randomL',
  'randomM',
  'randomN',
  'randomO',
  'randomP',
  'randomQ',
  'randomR',
  'randomS',
  'randomT',
  'randomU',
  'randomV',
  'randomW',
  'randomX',
  'randomY',
  'randomZ',
]
